SupportV2OrderListView = require('./v2_order_list_view.coffee')
SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $
SupportHelpWizardController = require('../../helpWizardController')

class SupportV2SelectDifferentOrderMenuView extends Backbone.View
  className: 'row select-order-menu'

  events :
    "click #purchasedDateSortOrders"  : "sortAndRender"
    "click #merchantNameSortOrders" : "sortAndRender"
    "click #chooseOrder"  : "chooseDifferentOrder"

  initialize: () ->
    @setSortParams()
    @template = SupportSelectDifferentOrderMenuTemplate
    @orderListView = new SupportV2OrderListView
      currentOrdersFilter: @currentOrdersFilter

  setSortParams : () ->
    @currentOrdersFilter = Groupon.Support.currentOrdersFilter
    @sortParams = {
      sort_attribute: @currentOrdersFilter.getSortAttribute()
      sort_order: @currentOrdersFilter.getSortOrder()
    }
    if @sortParams.sort_attribute is 'purchased_at'
      @currentSortElementId = 'purchasedDateSortOrders'
    else
      @currentSortElementId =  'merchantNameSortOrders'

    if @sortParams.sort_order is 'descending'
      @isDescSortOrder = true
    else
      @isDescSortOrder = false

  resetSortParams: () ->
    if @isDescSortOrder
      @sortParams.sort_order = 'descending'
    else
      @sortParams.sort_order = 'ascending'
    if @currentSortElementId  is 'purchasedDateSortOrders'
      @sortParams.sort_attribute = 'purchased_at'
    else
      @sortParams.sort_attribute = 'merchant_name'

  renderOrderListing: () ->
    @$el.html toHtml(@template, @toListingHash(), @I18nScope)
    @renderOrders()
    @delegateEvents()

  renderDetails: () ->
    @$el.html toHtml(@template, @toDetailHash(), @I18nScope)
    @delegateEvents()

  renderOrders: () ->
    @orderListView.removeView()
    @orderListView.currentOrdersFilter = @currentOrdersFilter
    @orderListView.render()
    @$el.find('.order-listing').html(@orderListView.el)

  toListingHash: () ->
    enableMerchantNameSortOrders: @currentSortElementId is 'purchasedDateSortOrders'
    isV2: true
    isOrderListing: true

  toDetailHash: () ->
    isV2: true
    isOrderdetails: true

  toSignInHash: () ->
    isV2: true
    showSignIn: true

  setCurrentFilter: () ->
    @resetSortParams()
    filter = Groupon.Support.OrdersCollection.getFilterInstance(@sortParams)
    filter.iterator.resetIterator()
    @currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter
    filter

  sortAndRender: (e)->
    currentjQuerySel = $(e.currentTarget)
    if @currentSortElementId == currentjQuerySel.attr('id')
      @isDescSortOrder = !@isDescSortOrder
    else
      @removeDisableClassFromPreviousSortLink()
      @currentSortElementId = currentjQuerySel.attr('id')
      @addDisableClassToSortLink(@currentSortElementId)
      @setDefaultSortOrder()
    @setCurrentFilter()
    @renderOrders()

  setDefaultSortOrder: () ->
    if @currentSortElementId is 'purchasedDateSortOrders'
      @isDescSortOrder = true
    else
      @isDescSortOrder = false

  removeDisableClassFromPreviousSortLink: ->
    ele = $('#' + @currentSortElementId)
    ele.removeClass "disabledLink"

  addDisableClassToSortLink: (selectorId)->
    ele = $('#'+selectorId)
    ele.addClass "disabledLink"

  chooseDifferentOrder: () ->
    SupportHelpWizardController.changeCurrentOrder(null)
    SupportHelpWizardController.initOrdersFetch()

module.exports = SupportV2SelectDifferentOrderMenuView
